module.exports = __webpack_public_path__ + "static/img/gameIntroduce_gray.9fcf9a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameIntroduce_gray.png
// module id = jpBM
// module chunks = 1